// dependencies
import React from "react";
import { format } from "date-fns";
import { useSelector } from "react-redux";

// api
import { generateRecentLoginsCsv } from "../../Api/services/marketing";

// components
import Button from "Components/Button";

// actions

// selectors
import { getCurrentEnvironmentName } from "../../Selectors/app";

// hooks

// utils
import { getApiDomain } from "../../Utils/getDomain";

// css
import css from "./Marketing.styl";

const Marketing = () => {
	const [isGeneratingCsv, setIsGeneratingCsv] = React.useState(false);
	const environment = useSelector(getCurrentEnvironmentName);

	const handleDownload = (count) => {
		const domain = getApiDomain();
		const today = format(new Date(), "yyyy-MM-dd");
		window.open(`${domain}/${environment}/marketing/download-recent-logins/${today}/${count}`, "_blank");
	};

	const handleGenerateRecentLogins = async () => {
		setIsGeneratingCsv(true);
		await generateRecentLoginsCsv(environment);
		setIsGeneratingCsv(false);
	};

	if (environment !== "production") {
		return (
			<div>
				<div className={css.content}>
					<div>This feature is only available on the production environment.</div>
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className={css.content}>
				<div className={css.section}>
					<div className={css.sectionInformation}>
						<div className={css.title}>Download recent logins (7 days)</div>
						<div className={css.description}>
							Download a CSV of users who have logged in recently. This is generated every night at
							midnight.
						</div>
					</div>

					<div className={css.sectionContent}>
						<Button onClick={() => handleDownload(7)}>Download Recent Logins Report</Button>
					</div>
				</div>

				<div className={css.section}>
					<div className={css.sectionInformation}>
						<div className={css.title}>Download recent logins (30 days)</div>
						<div className={css.description}>
							Download a CSV of users who have logged in recently. This is generated every night at
							midnight.
						</div>
					</div>

					<div className={css.sectionContent}>
						<Button onClick={() => handleDownload(30)}>Download Recent Logins Report</Button>
					</div>
				</div>

				<div className={css.section}>
					<div className={css.sectionInformation}>
						<div className={css.title}>Regenerate recent logins CSV</div>
						<div className={css.description}>
							{
								"Regenerate the recent logins CSV (above). You can use this if you need updated data or if today's CSV didn't generate for some reason. Please don't spam click this button."
							}
						</div>
					</div>

					<div className={css.sectionContent}>
						<Button isRequesting={isGeneratingCsv} onClick={handleGenerateRecentLogins}>
							Generate Recent Logins Report
						</Button>
					</div>
				</div>

				<div className={css.section}>
					<div className={css.sectionInformation}>
						<div className={css.title}>Get recently deactivated users</div>
						<div className={css.description}>
							Generates a CSV of recently deactivated users. This will take you to a new page.
						</div>
					</div>

					<div className={css.sectionContent}>
						<Button href="/deactivated" onClick={handleGenerateRecentLogins}>
							Go To Recently Deactivated
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Marketing;
